import BaseComponent from '../../../../../base/base_component';
import {BaseComponentParams} from "../../../../../base/base_component_interface";
import ClockComponentController from "../../../../clock/clock_controller_component";
import Device from "../../../../../utils/device";
import DOM from '../../../../../utils/dom';
import GameSessionTimerController from "../../../../game_session_timer/game_session_timer_controller";
import NetPositionController from "../../../../net_position/net_position_controller";

const templateView = require('./view/view.html');
export  const CANADA_ONTARIO_STRIP_COMPONENT_SELECTOR = 'cgp-canada-ontario-stripe-component';

interface ICanadaOntarioGameStripeComponentParams extends BaseComponentParams{
    gameType: number;
}

export default class CanadaOntarioGameStripeComponent extends BaseComponent {
    static CLASS = 'CanadaOntarioGameStripeComponent';

    _selector = CANADA_ONTARIO_STRIP_COMPONENT_SELECTOR;

    _netPositionController: NetPositionController = null;
    private params: ICanadaOntarioGameStripeComponentParams;

    init(params ) {
        params = params || {};

        params.innerHtml = templateView;
        super.init(params);

        this.params = params;

        this.start();
    }

    start() {
        super.start();

        const {gameType} = this.params;

        this._netPositionController = NetPositionController.create({gameType});
        const gameSessionTimer = GameSessionTimerController.create();

        this.appendChildComponent(this._netPositionController, '.cgp-stripe');

        if (Device.isMobileByOS()) {
            const clockComponentWrapper = this.createRootElement();

            DOM.addClass(clockComponentWrapper, 'cy-game-stripe-clock');
            clockComponentWrapper.appendChild(this._getClockComponent().getEl());

            this.querySelector('.cgp-stripe').appendChild(clockComponentWrapper);
        }

        this.appendChildComponent(gameSessionTimer, '.cgp-stripe');

        gameSessionTimer.start();

        return this;
    }

    onGameRoundEnd(){
        this._netPositionController?.onGameRoundEnd();
    }

    _getClockComponent() {
        const clockComponent = this.serviceFactory.componentFactoryService().createComponent(ClockComponentController, {
            datetime: this.serviceFactory.skinService().getTimeFormat()
        });

        clockComponent.start();

        return clockComponent;
    }
}